<template>
  <div>
    <div class="container mx-auto ">
      Administration - status
    </div>

    <button
      class="flex-no-shrink bg-teal hover:bg-teal-dark border-teal hover:border-teal-dark text-sm border-4 text-white py-1 px-2 rounded"
      type="button"
      @click="denormalizerReset"
    >
      Re-Denormalizer
    </button>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'AdminStatus',
    data () {
        return {
            status: null
        }
    },
    async mounted () {
        const response = await apiService.getAdminStatus()
        this.status = response.data
    },
    methods: {
        async denormalizerReset (key) {
            console.log('reprojecting ...')
            await apiService.reProject()
            console.log('done!')
        }
    }

}
</script>

<style scoped>

</style>